// src/app/mocks/mock-message-data.ts
import { NotificationItem } from '../models/notification.model';

export interface MessageItem {
  MessageId: number;
  Title: string;
  Content: string;
  Sender: string;
  Category: string;
  Priority: 'High' | 'Medium' | 'Low' | 'Normal';
  Timestamp: string;
  IsRead: boolean;
  Tags?: string[];
  Attachments?: string[];
  ThreadId?: number;
}

export interface MessageApiResponse {
  success: boolean;
  title?: string;
  body?: string;
  type?: string;
  created?: string;
  data: string | MessageItem[];
  message?: string;
}

export class MockMessageData {
  
  static readonly mockMessages: NotificationItem[] = [
    {
      notificationID: 999,
      title: 'Testovací HTML notifikace - Prodejní slevy (EN)',
      body: 'Mock data pro testování HTML generování - English localization',
      type: 1,
      created: '2025-01-04T10:00:00Z',
      senderUserID: 3,
      apnsPriority: 10,
      readAt: null,
      isRead: false
    },
    {
      notificationID: 998,
      title: 'Testovací HTML notifikace - Prodejní slevy (DE)',
      body: 'Mock data pro testování HTML generování - German localization',
      type: 1,
      created: '2025-01-04T09:30:00Z',
      senderUserID: 3,
      apnsPriority: 10,
      readAt: null,
      isRead: false
    },
    {
      notificationID: 997,
      title: 'Testovací HTML notifikace - Prodejní slevy (CZ)',
      body: 'Mock data pro testování HTML generování - Czech localization',
      type: 1,
      created: '2025-01-04T09:00:00Z',
      senderUserID: 3,
      apnsPriority: 10,
      readAt: null,
      isRead: false
    },
    {
      notificationID: 201,
      title: 'Důležité oznámení - Systémová údržba',
      body: 'Plánovaná údržba systému a související komunikace s uživateli. Obsahuje pokyny a časový harmonogram.',
      type: 4,
      created: '2025-03-22T09:00:00Z',
      senderUserID: 301,
      apnsPriority: 2,
      readAt: null,
      isRead: false
    },
    {
      notificationID: 202,
      title: 'Týmová komunikace - Q1 Review',
      body: 'Zprávy a komentáře týkající se quarterly review, zpětná vazba od týmů a plány na Q2.',
      type: 4,
      created: '2025-03-20T14:30:00Z',
      senderUserID: 302,
      apnsPriority: 1,
      readAt: '2025-03-20T15:00:00Z',
      isRead: true
    },
    {
      notificationID: 203,
      title: 'Zákaznické dotazy - Technická podpora',
      body: 'Kolekce zákaznických dotazů a požadavků na technickou podporu včetně prioritních případů.',
      type: 4,
      created: '2025-03-18T11:15:00Z',
      senderUserID: 303,
      apnsPriority: 2,
      readAt: null,
      isRead: false
    },
    {
      notificationID: 204,
      title: 'Projektové aktualizace',
      body: 'Souhrnné zprávy o průběhu projektů, milnících a blokujících issues od projektových manažerů.',
      type: 4,
      created: '2025-03-15T16:45:00Z',
      senderUserID: 304,
      apnsPriority: 1,
      readAt: '2025-03-15T17:00:00Z',
      isRead: true
    },
    {
      notificationID: 205,
      title: 'Bezpečnostní upozornění',
      body: 'Kritické bezpečnostní zprávy, varování a doporučené akce pro zabezpečení systémů.',
      type: 4,
      created: '2025-03-12T08:20:00Z',
      senderUserID: 305,
      apnsPriority: 3,
      readAt: null,
      isRead: false
    }
  ];

  private static readonly mockMessageDetailData: Record<string, MessageApiResponse> = {
    '999': {
      success: true,
      title: 'Testovací HTML notifikace - Prodejní slevy',
      body: 'Mock data pro testování HTML generování z stored procedure',
      type: 'msg',
      created: '2025-01-04T10:00:00Z',
      data: JSON.stringify({
        MsgContent: `
<style>
    .sales-card {
        background: #fff;
        border: 1px solid #ddd;
        border-left: 4px solid #007bff;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 15px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    .sales-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        padding-bottom: 15px;
        border-bottom: 1px solid #eee;
    }
    .document-title {
        margin: 0 0 8px 0;
        color: #333;
        font-size: 18px;
    }
    .store-badge {
        background: #e3f2fd;
        color: #1976d2;
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
    }
    .cashier-info {
        color: #555;
        font-size: 14px;
        margin-bottom: 15px;
    }
    .item-info {
        background: #f8f9fa;
        padding: 12px;
        border-radius: 6px;
        margin-bottom: 15px;
    }
    .item-code {
        background: #fff;
        border: 1px solid #dee2e6;
        padding: 3px 8px;
        border-radius: 4px;
        font-family: monospace;
        font-size: 13px;
        display: inline-block;
        margin-bottom: 8px;
    }
    .item-description {
        color: #333;
        font-size: 15px;
    }
    .price-info {
        display: flex;
        justify-content: space-between;
        gap: 20px;
    }
    .price-box, .discount-box {
        flex: 1;
    }
    .label {
        font-size: 12px;
        color: #666;
        text-transform: uppercase;
        margin-bottom: 4px;
    }
    .price-value {
        font-size: 20px;
        font-weight: 600;
        color: #28a745;
    }
    .discount-value {
        font-size: 20px;
        font-weight: 600;
        color: #dc3545;
    }
</style>
<div class="sales-card">
    <div class="sales-header">
        <div>
            <h3 class="document-title">Document 12345</h3>
            <span class="store-badge">Store 001</span>
        </div>
    </div>
    <div class="cashier-info">
        <strong>Cashier:</strong> Jan Novák - Marie Svobodová
    </div>
    <div class="item-info">
        <div class="item-code">Code: ITM-001234</div>
        <div class="item-description">Sportovní boty Nike Air Max - černá barva, velikost 42</div>
    </div>
    <div class="price-info">
        <div class="price-box">
            <div class="label">Price</div>
            <div class="price-value">2,599.00 CZK</div>
        </div>
        <div class="discount-box">
            <div class="label">Discount</div>
            <div class="discount-value">-450.00 CZK</div>
        </div>
    </div>
</div>
<div class="sales-card">
    <div class="sales-header">
        <div>
            <h3 class="document-title">Document 12346</h3>
            <span class="store-badge">Store 001</span>
        </div>
    </div>
    <div class="cashier-info">
        <strong>Cashier:</strong> Jan Novák - Marie Svobodová
    </div>
    <div class="item-info">
        <div class="item-code">Code: ITM-005678</div>
        <div class="item-description">Notebook Lenovo ThinkPad T14 Gen 3 - 16GB RAM, 512GB SSD</div>
    </div>
    <div class="price-info">
        <div class="price-box">
            <div class="label">Price</div>
            <div class="price-value">28,990.00 CZK</div>
        </div>
        <div class="discount-box">
            <div class="label">Discount</div>
            <div class="discount-value">-3,500.00 CZK</div>
        </div>
    </div>
</div>
<div class="sales-card">
    <div class="sales-header">
        <div>
            <h3 class="document-title">Document 12347</h3>
            <span class="store-badge">Store 002</span>
        </div>
    </div>
    <div class="cashier-info">
        <strong>Cashier:</strong> Petr Dvořák - Anna Černá
    </div>
    <div class="item-info">
        <div class="item-code">Code: ITM-009012</div>
        <div class="item-description">Samsung Galaxy S24 Ultra - 256GB, Phantom Black</div>
    </div>
    <div class="price-info">
        <div class="price-box">
            <div class="label">Price</div>
            <div class="price-value">32,990.00 CZK</div>
        </div>
        <div class="discount-box">
            <div class="label">Discount</div>
            <div class="discount-value">-5,000.00 CZK</div>
        </div>
    </div>
</div>`
      })
    },
    '998': {
      success: true,
      title: 'Testovací HTML notifikace - Prodejní slevy (DE)',
      body: 'Mock data pro testování HTML generování - German localization',
      type: 'msg',
      created: '2025-01-04T09:30:00Z',
      data: JSON.stringify({
        MsgContent: `
<style>
    .sales-card {
        background: #fff;
        border: 1px solid #ddd;
        border-left: 4px solid #007bff;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 15px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    .sales-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        padding-bottom: 15px;
        border-bottom: 1px solid #eee;
    }
    .document-title {
        margin: 0 0 8px 0;
        color: #333;
        font-size: 18px;
    }
    .store-badge {
        background: #e3f2fd;
        color: #1976d2;
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
    }
    .cashier-info {
        color: #555;
        font-size: 14px;
        margin-bottom: 15px;
    }
    .item-info {
        background: #f8f9fa;
        padding: 12px;
        border-radius: 6px;
        margin-bottom: 15px;
    }
    .item-code {
        background: #fff;
        border: 1px solid #dee2e6;
        padding: 3px 8px;
        border-radius: 4px;
        font-family: monospace;
        font-size: 13px;
        display: inline-block;
        margin-bottom: 8px;
    }
    .item-description {
        color: #333;
        font-size: 15px;
    }
    .price-info {
        display: flex;
        justify-content: space-between;
        gap: 20px;
    }
    .price-box, .discount-box {
        flex: 1;
    }
    .label {
        font-size: 12px;
        color: #666;
        text-transform: uppercase;
        margin-bottom: 4px;
    }
    .price-value {
        font-size: 20px;
        font-weight: 600;
        color: #28a745;
    }
    .discount-value {
        font-size: 20px;
        font-weight: 600;
        color: #dc3545;
    }
</style>
<div class="sales-card">
    <div class="sales-header">
        <div>
            <h3 class="document-title">Dokument 12345</h3>
            <span class="store-badge">Geschäft 001</span>
        </div>
    </div>
    <div class="cashier-info">
        <strong>Kassierer:</strong> Jan Novák - Marie Svobodová
    </div>
    <div class="item-info">
        <div class="item-code">Code: ITM-001234</div>
        <div class="item-description">Sportovní boty Nike Air Max - černá barva, velikost 42</div>
    </div>
    <div class="price-info">
        <div class="price-box">
            <div class="label">Preis</div>
            <div class="price-value">2.599,00 EUR</div>
        </div>
        <div class="discount-box">
            <div class="label">Rabatt</div>
            <div class="discount-value">-450,00 EUR</div>
        </div>
    </div>
</div>
<div class="sales-card">
    <div class="sales-header">
        <div>
            <h3 class="document-title">Dokument 12346</h3>
            <span class="store-badge">Geschäft 001</span>
        </div>
    </div>
    <div class="cashier-info">
        <strong>Kassierer:</strong> Jan Novák - Marie Svobodová
    </div>
    <div class="item-info">
        <div class="item-code">Code: ITM-005678</div>
        <div class="item-description">Notebook Lenovo ThinkPad T14 Gen 3 - 16GB RAM, 512GB SSD</div>
    </div>
    <div class="price-info">
        <div class="price-box">
            <div class="label">Preis</div>
            <div class="price-value">28.990,00 EUR</div>
        </div>
        <div class="discount-box">
            <div class="label">Rabatt</div>
            <div class="discount-value">-3.500,00 EUR</div>
        </div>
    </div>
</div>
<div class="sales-card">
    <div class="sales-header">
        <div>
            <h3 class="document-title">Dokument 12347</h3>
            <span class="store-badge">Geschäft 002</span>
        </div>
    </div>
    <div class="cashier-info">
        <strong>Kassierer:</strong> Petr Dvořák - Anna Černá
    </div>
    <div class="item-info">
        <div class="item-code">Code: ITM-009012</div>
        <div class="item-description">Samsung Galaxy S24 Ultra - 256GB, Phantom Black</div>
    </div>
    <div class="price-info">
        <div class="price-box">
            <div class="label">Preis</div>
            <div class="price-value">32.990,00 EUR</div>
        </div>
        <div class="discount-box">
            <div class="label">Rabatt</div>
            <div class="discount-value">-5.000,00 EUR</div>
        </div>
    </div>
</div>`
      })
    },
    '997': {
      success: true,
      title: 'Testovací HTML notifikace - Prodejní slevy (CZ)',
      body: 'Mock data pro testování HTML generování - Czech localization',
      type: 'msg',
      created: '2025-01-04T09:00:00Z',
      data: JSON.stringify({
        MsgContent: `
<style>
    .sales-card {
        background: #fff;
        border: 1px solid #ddd;
        border-left: 4px solid #007bff;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 15px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    .sales-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        padding-bottom: 15px;
        border-bottom: 1px solid #eee;
    }
    .document-title {
        margin: 0 0 8px 0;
        color: #333;
        font-size: 18px;
    }
    .store-badge {
        background: #e3f2fd;
        color: #1976d2;
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
    }
    .cashier-info {
        color: #555;
        font-size: 14px;
        margin-bottom: 15px;
    }
    .item-info {
        background: #f8f9fa;
        padding: 12px;
        border-radius: 6px;
        margin-bottom: 15px;
    }
    .item-code {
        background: #fff;
        border: 1px solid #dee2e6;
        padding: 3px 8px;
        border-radius: 4px;
        font-family: monospace;
        font-size: 13px;
        display: inline-block;
        margin-bottom: 8px;
    }
    .item-description {
        color: #333;
        font-size: 15px;
    }
    .price-info {
        display: flex;
        justify-content: space-between;
        gap: 20px;
    }
    .price-box, .discount-box {
        flex: 1;
    }
    .label {
        font-size: 12px;
        color: #666;
        text-transform: uppercase;
        margin-bottom: 4px;
    }
    .price-value {
        font-size: 20px;
        font-weight: 600;
        color: #28a745;
    }
    .discount-value {
        font-size: 20px;
        font-weight: 600;
        color: #dc3545;
    }
</style>
<div class="sales-card">
    <div class="sales-header">
        <div>
            <h3 class="document-title">Doklad 12345</h3>
            <span class="store-badge">Prodejna 001</span>
        </div>
    </div>
    <div class="cashier-info">
        <strong>Pokladní:</strong> Jan Novák - Marie Svobodová
    </div>
    <div class="item-info">
        <div class="item-code">Kód: ITM-001234</div>
        <div class="item-description">Sportovní boty Nike Air Max - černá barva, velikost 42</div>
    </div>
    <div class="price-info">
        <div class="price-box">
            <div class="label">Cena</div>
            <div class="price-value">2.599,00 CZK</div>
        </div>
        <div class="discount-box">
            <div class="label">Sleva</div>
            <div class="discount-value">-450,00 CZK</div>
        </div>
    </div>
</div>
<div class="sales-card">
    <div class="sales-header">
        <div>
            <h3 class="document-title">Doklad 12346</h3>
            <span class="store-badge">Prodejna 001</span>
        </div>
    </div>
    <div class="cashier-info">
        <strong>Pokladní:</strong> Jan Novák - Marie Svobodová
    </div>
    <div class="item-info">
        <div class="item-code">Kód: ITM-005678</div>
        <div class="item-description">Notebook Lenovo ThinkPad T14 Gen 3 - 16GB RAM, 512GB SSD</div>
    </div>
    <div class="price-info">
        <div class="price-box">
            <div class="label">Cena</div>
            <div class="price-value">28.990,00 CZK</div>
        </div>
        <div class="discount-box">
            <div class="label">Sleva</div>
            <div class="discount-value">-3.500,00 CZK</div>
        </div>
    </div>
</div>
<div class="sales-card">
    <div class="sales-header">
        <div>
            <h3 class="document-title">Doklad 12347</h3>
            <span class="store-badge">Prodejna 002</span>
        </div>
    </div>
    <div class="cashier-info">
        <strong>Pokladní:</strong> Petr Dvořák - Anna Černá
    </div>
    <div class="item-info">
        <div class="item-code">Kód: ITM-009012</div>
        <div class="item-description">Samsung Galaxy S24 Ultra - 256GB, Phantom Black</div>
    </div>
    <div class="price-info">
        <div class="price-box">
            <div class="label">Cena</div>
            <div class="price-value">32.990,00 CZK</div>
        </div>
        <div class="discount-box">
            <div class="label">Sleva</div>
            <div class="discount-value">-5.000,00 CZK</div>
        </div>
    </div>
</div>`
      })
    },
    '201': {
      success: true,
      title: 'Důležité oznámení - Systémová údržba',
      body: 'Plánovaná údržba systému a související komunikace s uživateli',
      type: 'system',
      created: '2025-03-22T09:00:00Z',
      data: [
        {
          MessageId: 1001,
          Title: 'Plánovaná údržba serveru - 25.3.2025',
          Content: 'Informujeme vás o plánované údržbě serverů, která se bude konat v neděli 25. března od 02:00 do 06:00. Během této doby může být systém nedostupný. Doporučujeme dokončit všechny důležité úkoly do soboty večera.',
          Sender: 'IT Administrátor',
          Category: 'Systém',
          Priority: 'High',
          Timestamp: '2025-03-22T09:00:00Z',
          IsRead: false,
          Tags: ['údržba', 'server', 'downtime']
        },
        {
          MessageId: 1002,
          Title: 'Aktualizace bezpečnostních certifikátů',
          Content: 'V rámci údržby budou aktualizovány všechny bezpečnostní certifikáty. Uživatelé se mohou během této doby setkat s upozorněními v prohlížečích, která lze bezpečně ignorovat.',
          Sender: 'Bezpečnostní tým',
          Category: 'Bezpečnost',
          Priority: 'Medium',
          Timestamp: '2025-03-22T09:15:00Z',
          IsRead: true,
          Tags: ['certifikáty', 'bezpečnost']
        },
        {
          MessageId: 1003,
          Title: 'Nová verze aplikace po údržbě',
          Content: 'Po dokončení údržby bude nasazena nová verze aplikace v2.4.1 s vylepšeními výkonu a opravami chyb. Changelog naleznete v dokumentaci.',
          Sender: 'Vývojový tým',
          Category: 'Aktualizace',
          Priority: 'Medium',
          Timestamp: '2025-03-22T10:30:00Z',
          IsRead: true,
          Tags: ['update', 'verze', 'changelog']
        }
      ]
    },
    '202': {
      success: true,
      title: 'Týmová komunikace - Q1 Review',
      body: 'Zprávy a komentáře týkající se quarterly review',
      type: 'team',
      created: '2025-03-20T14:30:00Z',
      data: [
        {
          MessageId: 2001,
          Title: 'Q1 výsledky - Prodejní tým',
          Content: 'Prodejní tým dosáhl 108% plánovaného cíle za Q1. Výborná práce všech! Speciální poděkování patří Marii za získání klíčového klienta TechCorp.',
          Sender: 'Jana Nováková - Sales Manager',
          Category: 'Výsledky',
          Priority: 'Medium',
          Timestamp: '2025-03-20T14:30:00Z',
          IsRead: true,
          Tags: ['Q1', 'prodeje', 'výsledky']
        },
        {
          MessageId: 2002,
          Title: 'Vývojový tým - Delivered features',
          Content: 'V Q1 jsme úspěšně dokončili 23 z 25 plánovaných features. Dvě zbývající budou přesunuty na začátek Q2. Code quality metriky zůstávají na vysoké úrovni 94%.',
          Sender: 'Tomáš Dvořák - Lead Developer',
          Category: 'Vývoj',
          Priority: 'Low',
          Timestamp: '2025-03-20T15:45:00Z',
          IsRead: false,
          Tags: ['vývoj', 'features', 'kvalita']
        },
        {
          MessageId: 2003,
          Title: 'Marketing ROI - Q1 shrnutí',
          Content: 'Marketingové kampaně v Q1 dosáhly průměrného ROI 340%. Nejúspěšnější byl email marketing s 450% ROI. Doporučuji navýšit budget pro Q2.',
          Sender: 'Klára Svobodová - Marketing Lead',
          Category: 'Marketing',
          Priority: 'Medium',
          Timestamp: '2025-03-20T16:20:00Z',
          IsRead: true,
          Tags: ['marketing', 'ROI', 'kampaně']
        },
        {
          MessageId: 2004,
          Title: 'Q2 Planning - Další kroky',
          Content: 'Na základě Q1 výsledků navrhuji následující priority pro Q2: 1) Expansion do nových regionů, 2) Product improvements based na customer feedback, 3) Team scaling.',
          Sender: 'CEO - Pavel Černý',
          Category: 'Strategie',
          Priority: 'High',
          Timestamp: '2025-03-20T17:00:00Z',
          IsRead: false,
          Tags: ['Q2', 'planning', 'strategie']
        }
      ]
    },
    '203': {
      success: true,
      title: 'Zákaznické dotazy - Technická podpora',
      body: 'Kolekce zákaznických dotazů a požadavků na technickou podporu',
      type: 'support',
      created: '2025-03-18T11:15:00Z',
      data: [
        {
          MessageId: 3001,
          Title: 'URGENT: Výpadek systému u ABC Corp',
          Content: 'Zákazník ABC Corp hlásí úplný výpadek systému od 10:30. Ovlivněno 200+ uživatelů. Požadují okamžité řešení a kompenzaci za výpadek.',
          Sender: 'Support Ticket #2024-001',
          Category: 'Kritické',
          Priority: 'High',
          Timestamp: '2025-03-18T11:15:00Z',
          IsRead: false,
          Tags: ['urgentní', 'výpadek', 'ABC Corp']
        },
        {
          MessageId: 3002,
          Title: 'Požadavek na novou funkcionalitu',
          Content: 'XYZ Solutions požaduje implementaci custom reportingu. Ochotni zaplatit dodatečný poplatek. Termín do konce měsíce. Potřebujeme assessment od dev týmu.',
          Sender: 'Account Manager - Lisa',
          Category: 'Feature Request',
          Priority: 'Medium',
          Timestamp: '2025-03-18T13:20:00Z',
          IsRead: true,
          Tags: ['feature', 'custom', 'XYZ Solutions']
        },
        {
          MessageId: 3003,
          Title: 'Performance issues - TechStart',
          Content: 'TechStart hlásí pomalé načítání dashboardu (8+ sekund). Uživatelská base rostla o 300% za posledních 6 měsíců. Možná potřeba optimalizace.',
          Sender: 'Technical Support',
          Category: 'Performance',
          Priority: 'Medium',
          Timestamp: '2025-03-18T14:45:00Z',
          IsRead: false,
          Tags: ['výkon', 'optimalizace', 'TechStart']
        },
        {
          MessageId: 3004,
          Title: 'Data export - Local Business',
          Content: 'Local Business potřebuje export všech dat před migrací na konkurenční řešení. Deadline 31.3. Potřebujeme koordinaci s data týmem.',
          Sender: 'Customer Success',
          Category: 'Data Export',
          Priority: 'Low',
          Timestamp: '2025-03-18T16:10:00Z',
          IsRead: true,
          Tags: ['export', 'migrace', 'deadline']
        }
      ]
    },
    '204': {
      success: true,
      title: 'Projektové aktualizace',
      body: 'Souhrnné zprávy o průběhu projektů a milnících',
      type: 'projects',
      created: '2025-03-15T16:45:00Z',
      data: [
        {
          MessageId: 4001,
          Title: 'Projekt Alpha - Milestone 2 dokončen',
          Content: 'Úspěšně jsme dokončili Milestone 2 projektu Alpha. Všechny plánované deliverables byly dodány včas a v rámci rozpočtu. Připravujeme se na finální fázi.',
          Sender: 'PM - Andrea Krásná',
          Category: 'Milestone',
          Priority: 'Medium',
          Timestamp: '2025-03-15T16:45:00Z',
          IsRead: true,
          Tags: ['Alpha', 'milestone', 'dokončeno']
        },
        {
          MessageId: 4002,
          Title: 'BLOKOVÁNO: Projekt Beta - Čekáme na klienta',
          Content: 'Projekt Beta je aktuálně blokován čekáním na schválení design mockupů od klienta. Deadline je 20.3., jinak se posune celý timeline o 2 týdny.',
          Sender: 'PM - Martin Novák',
          Category: 'Blokováno',
          Priority: 'High',
          Timestamp: '2025-03-15T17:20:00Z',
          IsRead: false,
          Tags: ['Beta', 'blokováno', 'deadline']
        },
        {
          MessageId: 4003,
          Title: 'Projekt Gamma - Budget update',
          Content: 'Projekt Gamma překročil původní odhad o 15% kvůli dodatečným požadavkům klienta. Všechny změny byly schváleny change requestem.',
          Sender: 'PM - Petr Svoboda',
          Category: 'Budget',
          Priority: 'Medium',
          Timestamp: '2025-03-15T18:00:00Z',
          IsRead: true,
          Tags: ['Gamma', 'budget', 'change request']
        }
      ]
    },
    '205': {
      success: true,
      title: 'Bezpečnostní upozornění',
      body: 'Kritické bezpečnostní zprávy a varování',
      type: 'security',
      created: '2025-03-12T08:20:00Z',
      data: [
        {
          MessageId: 5001,
          Title: 'KRITICKÉ: Detekován pokus o průnik',
          Content: 'Náš security systém detekoval několik pokusů o neautorizovaný přístup z IP adres v Rusku a Číně. Všechny pokusy byly zablokováны. Doporučujeme kontrolu access logů.',
          Sender: 'Security Team',
          Category: 'Intrusion',
          Priority: 'High',
          Timestamp: '2025-03-12T08:20:00Z',
          IsRead: false,
          Tags: ['kritické', 'průnik', 'zabezpečení']
        },
        {
          MessageId: 5002,
          Title: 'Nová security policy - 2FA povinné',
          Content: 'Od 1.4.2025 bude dvoufaktorová autentifikace povinná pro všechny administrátorské účty. Prosím, nastavte si 2FA nejpozději do 31.3.',
          Sender: 'IT Security',
          Category: 'Policy',
          Priority: 'Medium',
          Timestamp: '2025-03-12T09:45:00Z',
          IsRead: true,
          Tags: ['2FA', 'policy', 'deadline']
        },
        {
          MessageId: 5003,
          Title: 'Phishing alert - Falešné emaily',
          Content: 'Zaznamenali jsme zvýšený počet phishing emailů cílících na naše zaměstnance. Emaily se tváří jako IT podpora a žádají hesla. NIKDY nesdílejte přihlašovací údaje!',
          Sender: 'Security Awareness',
          Category: 'Phishing',
          Priority: 'High',
          Timestamp: '2025-03-12T14:30:00Z',
          IsRead: false,
          Tags: ['phishing', 'varování', 'hesla']
        },
        {
          MessageId: 5004,
          Title: 'Audit výsledky - Březen 2025',
          Content: 'Dokončen měsíční bezpečnostní audit. Nalezeno 3 minor vulnerabilities, které budou opraveny do konce týdne. Celkové security score: 94/100.',
          Sender: 'Security Audit',
          Category: 'Audit',
          Priority: 'Low',
          Timestamp: '2025-03-12T16:15:00Z',
          IsRead: true,
          Tags: ['audit', 'vulnerabilities', 'score']
        }
      ]
    }
  };

  static getMessageList(): NotificationItem[] {
    return [...this.mockMessages];
  }

  static getMessageDetail(messageId: string): MessageApiResponse {
    return this.mockMessageDetailData[messageId] || {
      success: false,
      message: 'Messages not found',
      data: []
    };
  }

  static addMockMessage(message: NotificationItem): void {
    this.mockMessages.push(message);
  }

  static markMessageAsRead(messageId: string, messageDetailId: number): void {
    const messageData = this.mockMessageDetailData[messageId];
    if (messageData && Array.isArray(messageData.data)) {
      const message = (messageData.data as MessageItem[]).find(m => m.MessageId === messageDetailId);
      if (message) {
        message.IsRead = true;
      }
    }
  }

  static resetData(): void {
    // TODO
    }
}